import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PwaService } from 'src/app/services/pwa.service';

@Component({
  selector: 'app-pwa-installation',
  templateUrl: './pwa-installation.component.html',
  styleUrls: ['./pwa-installation.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class PwaInstallationComponent {

  
  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly pwaService: PwaService,
  ) {}
  
  public showInstructions = this.isIos() || this.isIosSafari()

  public isIos(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  }
  
  public isIosSafari(): boolean {
    const ua = window.navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    return isIOS && isSafari;
  }  

  public install(): void {
    this.activeModal.dismiss()
    this.pwaService.installPWA()
  }

  public dismiss(): void {
    this.activeModal.dismiss()
  }


}
